import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useFooterAnimationContext } from '../../context/FooterAnimationContext/index.js';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import { getDynamicLayoutData } from '../../utils/functions/getDynamicLayoutData/getDynamicLayoutData.js';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import { SlideInUpTransition } from '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import { useMockContext } from '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../components/IconButton/IconButton.js';
import { VerticalAccordion } from '../../components/Accordion/components/VerticalAccordion/VerticalAccordion.js';
import { AccordionItem } from '../../components/Accordion/components/AccordionItem/AccordionItem.js';
import { AnimatePresence } from '../../components/AnimatePresence/AnimatePresence.js';
import { VerticalDrawerAnimation } from '../../components/AnimatePresence/animations/VerticalDrawerAnimation/VerticalDrawerAnimation.js';
import { isUserLinkingWallet } from '../../shared/utils/functions/isUserLinkingWallet/isUserLinkingWallet.js';
import { Footer } from './Footer/Footer.js';
import { EmptyFooterContent } from './FooterContent/EmptyFooterContent/empty-footer-content.js';
import { WalletMoreInfoContent } from './FooterContent/WalletMoreInfoContent/WalletMoreInfoContent.js';
import { WalletListFooterContent } from './FooterContent/WalletListFooterContent/WalletListFooterContent.js';
import { Header } from './Header/header.js';

const DynamicAuthLayout = ({ appName, children, onClose, newToWeb3WalletChainMap, transitionProps, projectSettings, walletConnector, walletName = '', className = '', }) => {
    const { view } = useViewContext();
    const { user } = useInternalDynamicContext();
    const { headerData, footerData } = getDynamicLayoutData({
        view,
    });
    const footerRef = useRef(null);
    const { isFooterExpanded } = useFooterAnimationContext();
    const { mockedSDK } = useMockContext();
    const renderFooterContent = () => {
        switch (view) {
            case 'wallet-connect-mobile-wallets-list':
            case 'wallet-list':
            case 'login-with-email-or-wallet-full-wallet-list':
                return (jsx(WalletListFooterContent, { chains: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.chains, newToWeb3WalletChainMap: newToWeb3WalletChainMap }));
            case 'pending-signature-without-back-button':
            case 'pending-signature':
                return (jsx(WalletMoreInfoContent, { appName: appName, variant: 'sign', walletName: walletName }));
            case 'pending-connect':
                return jsx(WalletMoreInfoContent, { appName: appName, variant: 'connect' });
            case 'qr-code':
                return jsx(WalletMoreInfoContent, { appName: appName, variant: 'connect' });
            /* istanbul ignore next */
            default:
                return jsx(EmptyFooterContent, {});
        }
    };
    const showFooter = 
    // Notice the negation here
    !((view === 'qr-code' && !(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.canConnectViaQrCode)) ||
        view === 'no-qr-not-installed' ||
        view === 'wallet-used' ||
        view === 'chainalysis-blocked-wallet' ||
        view === 'wallet-sign' ||
        view === 'collect-user-data' ||
        isUserLinkingWallet(user, view, mockedSDK));
    const showHeader = view !== 'collect-user-data' &&
        view !== 'no-access' &&
        view !== 'chainalysis-blocked-wallet' &&
        view !== 'update-email' &&
        view !== 'verify-email' &&
        view !== 'network-not-supported' &&
        view !== 'email-wallet-otp-verification-view';
    const content = (jsxs(Fragment, { children: [showHeader && (jsx(Header, { onClose: onClose, heading: (headerData === null || headerData === void 0 ? void 0 : headerData.heading) || '', projectSettings: projectSettings })), children] }));
    const modalClassName = classNames(className, 'dynamic-auth-layout__container');
    return (jsx("div", Object.assign({ className: 'dynamic-auth-layout__modal' }, { children: jsx(SlideInUpTransition, Object.assign({ isShown: Boolean(transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.isShown) }, { children: jsx("div", Object.assign({ className: modalClassName, "data-testid": 'dynamic-auth-modal' }, { children: jsxs(VerticalAccordion, { children: [jsx(AccordionItem, Object.assign({ isOpen: !isFooterExpanded }, { children: content })), jsx(AnimatePresence, Object.assign({ animationComponent: jsx(VerticalDrawerAnimation, {}) }, { children: footerData && showFooter && (jsx(Footer, { icon: footerData.icon, heading: footerData.heading, footerRef: footerRef, projectSettings: projectSettings })) })), footerData && showFooter && (jsx(AccordionItem, Object.assign({ isOpen: isFooterExpanded }, { children: jsx("div", { children: renderFooterContent() }, isFooterExpanded.toString()) })))] }) })) })) })));
};

export { DynamicAuthLayout };
